import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { ConnexionService } from './connexion.service';
import { AppGlobal } from './app.global';

@Injectable()
export class ConnexionGuard implements CanActivate {

  constructor(private connexionService: ConnexionService, private router: Router, private appGlobal: AppGlobal) {}

  canActivate() {
    if (!this.connexionService.isAuthenticated() && this.appGlobal.isNeedAuth()) {
      this.router.navigate(['/interdit']);
      return null;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/connexion-guard.service.ts